/* 
These keys are meant to be client side https://developer.mixpanel.com/reference/project-token#managing-a-projects-token
 We could have them be NEXT_PUBLIC vars but stage and prod are the same builds, and we don't use next for Miles build, 
 which uses this lib so here we are 
*/

export const MIXPANEL_TOKEN = (() => {
    if (typeof window === "undefined") return "630af3c6606438f15fd230033d3644be";

    if (window.location.origin.includes("localhost")) return "630af3c6606438f15fd230033d3644be";
    if (window.location.origin.includes("dev.")) return "630af3c6606438f15fd230033d3644be";
    if (window.location.origin.includes("test.")) return "fe73427da4e18cc1f16dc8acbf93bb83";
    if (window.location.origin.includes("stage.")) return "fe73427da4e18cc1f16dc8acbf93bb83";
    return "5014a17389ba7accd2f73f4ce977de26";
})();
